// extracted by mini-css-extract-plugin
export var searchHeader = "_a2-0";
export var searchHeaderDark = "_a2-1";